import React, { useEffect, useState } from 'react';
import Layout from '@components/common/Layout';
import { getPfmsSimulLink } from '@common/utils';

const PfmsSimul = () => {
  const [pfmsSimulUrl, setPfmsSimulUrl] = useState('');

  if(pfmsSimulUrl != '')  window.parent.document.getElementById('pfmsSimul').src = pfmsSimulUrl;

  useEffect(async() => {
    setPfmsSimulUrl(await getPfmsSimulLink());
    window.parent.document.getElementById('pfmsSimul').src = pfmsSimulUrl;
  }, []);

  useEffect(() => {
    window.parent.document.getElementById('pfmsSimul').src = pfmsSimulUrl;
  }, [pfmsSimulUrl]);
  
  return (
    <Layout>    
      <iframe id="pfmsSimul" className="con-wrap tablet" style={{ padding: 0 }}/>
    </Layout>
  )
};


export default PfmsSimul;
